import type { Track } from '@tla/types';

/**
 * Default Lakeside Park Raceway seed. The outline is left undefined and derived
 * from GPS on first use; centre and start/finish give the map an initial frame.
 * Coordinates are [longitude, latitude].
 */
export const LAKESIDE: Omit<Track, 'id'> = {
  name: 'Lakeside',
  centre: [152.9661, -27.2286],
  length: 2410,
  startFinish: {
    id: 'lakeside-sf',
    name: 'Start/Finish',
    a: [152.96555, -27.22895],
    b: [152.96575, -27.22835],
  },
  sectors: [],
};
